export default "__VITE_ASSET__BE0V6xnp__"